import { render, staticRenderFns } from "./Buckler.vue?vue&type=template&id=7b9ad28a&"
import script from "./Buckler.vue?vue&type=script&lang=ts&"
export * from "./Buckler.vue?vue&type=script&lang=ts&"
import style0 from "./Buckler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports